import { ParsedUrlQuery } from "querystring";

export function getRouteFromQueryParams(query: { [k: string]: string; } | ParsedUrlQuery): VisitRoute | undefined {
	if (query.gclid) return "google";
	if (query.msclkid) return "bing";
	if (query.fbclid) return "facebook";
	if (query.twclid) return "twitter";
	if (query.ttclid) return "tiktok";
	return undefined;
}